// export default EmiDueReport;
import React, { useMemo, useState ,useEffect} from "react";
import { Link } from "react-router-dom";
import "../css/AreaSurveyReport.css";
import toast, { Toaster } from "react-hot-toast";
import axios from "axios";


const AreaSurveyReport = () => {
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // 🔍 Search + Pagination
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [modalOpen, setModalOpen] = useState(false);
  const [adminRemark, setAdminRemark] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedreport,setselectedreport]=useState("");
  const [staticData,setStaticData]= useState([]);

  

 useEffect(() => {
  fetchData();
  }, []);


  const fetchData = async () => {
      try {
        const superAdminId = localStorage.getItem("adminuserId");
        // console.log("superAdmin:", superAdmin);
        const response = await axios.get(
          `https://payyug.in/api/get-all-areasurvay?superAdmin=${superAdminId}`,{
             headers: {
              "x-api-key": "hQIJOEokqdWBA76897tJfBKJASB2" ,
              "Content-Type": "application/json"
            }
          }
        );
        console.log("response_data",response.data);
        setStaticData(response.data.data);
      } catch (err) {
        console.error("Error fetching area survey data:", err); 
      }
    };

 
 
// search and filter logic
  const filteredStaticData = useMemo(() => {
    let data = [...staticData];

    if (searchQuery.trim()) {
      data = data.filter((item) =>
        Object.values(item)
          .join(" ")
          .toLowerCase()
          .includes(searchQuery.toLowerCase())
      );
    }

    return data;
  }, [searchQuery,staticData]);

// pagination
  const totalPagesFD = Math.ceil(filteredStaticData.length / rowsPerPage);

  const paginatedDataFD = filteredStaticData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );
 
  // useEffect(() => {
  //  console.log("selected report UPDATED : ", selectedreport);
  // }, [selectedreport]);

  const openRemarkModal = (report,status) => {
    setselectedreport(report);
    console.log("report : ",report);
    // console.log("selected report : ",selectedreport);
    setSelectedStatus(status);
    setAdminRemark("");
    setModalOpen(true);
  };

  const submitStatusUpdate = async () => {
      if (!adminRemark.trim()) {
        return toast.error("Admin remark is required!");
      }
       const userId = localStorage.getItem("userId") || 5;
       try {
        await axios.post(
          `https://payyug.in/api/area-survay/${selectedreport.id}/${selectedStatus}`,
          {
            approvedby_id: userId,
            remark:adminRemark,
          }
        );
        
        toast.success(`acc ${selectedStatus} successfully`);
        await fetchData();
        } catch (error) {
        toast.error(error?.response?.data?.error || "Failed to update account");
        setModalOpen(false);
      }
     setModalOpen(false);
  };

  return (
    <div className="area-survey-report-container">
      <h1 className="area-survey-report-title">Area Survey Report</h1>

      {/* Rows per page */}
      <div className="area-survey-report-filters">
        <input
          type="text"
          placeholder="Search by any field..."
          value={searchQuery}
          className="search-filter-asr"
          onChange={(e) => {
            setSearchQuery(e.target.value);
            setCurrentPage(1);
          }}
        />

        <label>
          Show{" "}
          <select
            value={rowsPerPage}
            onChange={(e) => {
              setRowsPerPage(Number(e.target.value));
              setCurrentPage(1);
            }}
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>{" "}
          entries
        </label>
      </div>

      {/* Search input */}
      {/* <div className="DDFDReportsearch-box">
        <input
          type="text"
          placeholder="Search by any field..."
          value={searchQuery}
          onChange={(e) => {
            setSearchQuery(e.target.value);
            setCurrentPage(1);
          }}
        />
      </div> */}

      {/* Table */}
      <div className="area-survey-report-section">
        <table className="area-survey-report-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Branch</th>
              <th>Survey Start Date</th>
              <th>Employee</th>
              <th>Area Name</th>
              <th>Village Name</th>
              <th>Population of village</th>
              <th>Political Situation</th>
              <th>Name of MFI</th>
                            <th>status</th>

              <th>View Report</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {paginatedDataFD.length === 0 ? (
              <tr>
                <td colSpan="10" className="area-survey-report-no-records">
                  ✅ No records found
                </td>
              </tr>
            ) : (
              paginatedDataFD.map((item, i) => (
                <tr key={i}>
                  <td>{(currentPage - 1) * rowsPerPage + i + 1}</td>
                  <td>{item.branch?item.branch:"Muzaffarpur(dummy)"}</td>
                  <td>
                    {new Date(item.surveyDate).toLocaleDateString("en-IN")}
                  </td>
                  <td>{item.employee?item.employee:"Abhishek Kumar(dummy)"}</td>
                  <td>{item.areaName}</td>
                  <td>{item.villageName}</td>
                  <td>{item.populationOfVillage}</td>
                  <td>{item.politicalSituation}</td>
                  <td>{item.mfiNames}</td>
                  <td>{item.status}</td>
                  <td>
                    <Link to={"/viewAreaSurveyReport"} className="area-survey-view-report">view</Link>
                  </td>
                  <td>
                      <div className="action-buttons-asr">
                     {item?.status === "approved" ? (
                        <button
                          className="approve-btn"
                          disabled
                        >
                          Approved
                        </button>
                      ) : (
                        <button
                          className="approve-btn"
                          onClick={() => openRemarkModal(item, "approve")}
                        >
                          Approve
                        </button>
                      )}


                        <button
                          className="reject-btn"
                          onClick={() => openRemarkModal(item,"reject")}
                        >
                          Reject
                        </button>
                      </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="area-survey-report-pagination-btns">
        <button
          onClick={() => setCurrentPage((p) => p - 1)}
          disabled={currentPage === 1}
        >
          ⬅ Previous
        </button>

        <span>
          Page {currentPage} of {totalPagesFD || 1}
        </span>

        <button
          onClick={() => setCurrentPage((p) => p + 1)}
          disabled={currentPage === totalPagesFD || totalPagesFD === 0}
        >
          Next ➡
        </button>
      </div>

      {/* Modal */}
      {modalOpen && (
        <div className="remark-modal-overlay">
          <div className="remark-modal">
            <h3>
              {selectedStatus === "approve" ? "Approve report": "Reject report"}
            </h3>

            <textarea
              placeholder="Enter admin remark"
              value={adminRemark}
              onChange={(e) => setAdminRemark(e.target.value)}
            ></textarea>

            <div className="modal-buttons">
              <button className="modal-submit" onClick={submitStatusUpdate}>
                Submit
              </button>
              <button
                className="modal-cancel"
                onClick={() => setModalOpen(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default AreaSurveyReport;
